import { darken, transparentize } from 'polished';
import { themeGet } from '@styled-system/theme-get';
import { ON_HOVER_DARKEN_ALPHA, ON_CLICK_DARKEN_ALPHA, ON_HOVER_TRANSPARENTIZE_ALPHA, ON_CLICK_TRANSPARENTIZE_ALPHA } from './theme';
export const fontStack = (fonts) => fonts.join(',');
export const getHoverColor = (props) => {
    const { variant, color, theme } = props;
    if (variant === 'primary' || variant === 'secondary') {
        return darken(ON_HOVER_DARKEN_ALPHA, themeGet('colors.' + color, color)({ theme }));
    }
    else {
        return transparentize(ON_HOVER_TRANSPARENTIZE_ALPHA, themeGet('colors.' + color, color)({ theme }));
    }
};
export const getClickColor = (props) => {
    const { variant, color, theme } = props;
    if (variant === 'primary' || variant === 'secondary') {
        return darken(ON_CLICK_DARKEN_ALPHA, themeGet('colors.' + color, color)({ theme }));
    }
    else {
        return transparentize(ON_CLICK_TRANSPARENTIZE_ALPHA, themeGet('colors.' + color, color)({ theme }));
    }
};
//# sourceMappingURL=utils.js.map